import * as React from "react";

import { cn } from "@/lib/utils";

// Native select for the editor panels. Those panels are translucent glass
// cards, often nested inside another card, so a transparent control with the
// stock border blends into them. A solid, darker-than-card fill and a lighter
// border make it read as an inset field. Shares FIELD_CLASSES with the other
// editor inputs (e.g. the time adjuster) so they stay consistent.
export const FIELD_CLASSES =
  "h-10 w-full rounded-md border border-white/10 bg-background/80 px-3 text-sm shadow-inner transition-colors hover:border-white/20 focus-visible:outline-none focus-visible:border-primary/50 focus-visible:ring-2 focus-visible:ring-ring/40 disabled:cursor-not-allowed disabled:opacity-50";

const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      FIELD_CLASSES,
      // The open option list is drawn by the OS; give it the dark popover fill.
      "[&>option]:bg-popover [&>option]:text-popover-foreground",
      className
    )}
    {...props}
  />
));
Select.displayName = "Select";

export { Select };
